import { EnvironmentProviders, Provider } from '@angular/core';
import { PublicClientApplication } from '@azure/msal-browser';
import { MSAL_INSTANCE, MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { MsalAuthConfig } from '../config/app-config.token';
import { buildMsalConfiguration } from './msal-configuration.factory';

export const provideCoreAuth = (msal: MsalAuthConfig): (Provider | EnvironmentProviders)[] => [
  {
    provide: MSAL_INSTANCE,
    useFactory: () => new PublicClientApplication(buildMsalConfiguration(msal)),
  },
  MsalService,
  MsalBroadcastService,
];
